import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class ApiCancelService {
  private cancelSubject = new Subject<void>()

  private _isLoggingOut = false

  readonly cancelPending$ = this.cancelSubject.asObservable()

  get isLoggingOut(): boolean {
    return this._isLoggingOut
  }

  startLogout() {
    this._isLoggingOut = true
    this.cancelSubject.next()
  }

  resetLogout() {
    this._isLoggingOut = false
  }
}
